import { useContext } from "react";
import AuthContext from "../store/auth-cxt";

export default function useAuth() {
  return useContext(AuthContext);
}
